import "../WalletTopUpModal/WalletTopUpModal.css";

import React, { useState } from "react";
import { createPayout } from "Config/API/action";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

const WalletPayoutModal = ({ hide, token, accountId, onSuccess }) => {
  const canPayout =
    useSelector((state) => state.authenticationReducer)?.credit_account_manager ===
    "manager";
  const [amount, setAmount] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (!canPayout) return null;

  const handleSubmit = async () => {
    if (submitting) return;

    const numericAmount = Number(amount);
    if (!numericAmount || numericAmount <= 0) {
      toast("Please enter a valid payout amount.", { type: "info" });
      return;
    }

    if (!accountId) {
      toast("Stripe account is not connected. Please connect your account first.", {
        type: "error",
      });
      return;
    }

    setSubmitting(true);
    try {
      const res = await createPayout(token, accountId, numericAmount);
      if (res?.status) {
        toast(res?.message || "Payout created successfully.", { type: "success" });
        await onSuccess?.();
        hide(false);
            window.location.reload();
        return;
      }
      toast(res?.message || "Unable to create payout. Please try again.", {
        type: "error",
      });
    } catch {
      toast("Unable to create payout. Please try again.", { type: "error" });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="wallet-topup-overlay">
      <div className="wallet-topup-modal">
        <div className="wallet-topup-header">
          <h3>Payout</h3>
          <span className="wallet-topup-close" onClick={() => hide(false)}>
            X
          </span>
        </div>

        <input
          type="number"
          className="wallet-topup-field"
          placeholder="Enter payout amount"
          value={amount}
          min="1"
          onChange={(e) => setAmount(e.target.value)}
          disabled={submitting}
        />
        <p style={{ marginTop: "8px", fontSize: "12px", color: "#6b7280" }}>
          Standard payouts typically arrive in 2-3 business days after Stripe
          initiates the payout.
        </p>

        <div className="wallet-topup-actions">
          <button
            className="wallet-topup-primary"
            onClick={handleSubmit}
            disabled={submitting}
          >
            {submitting ? "Processing..." : "Submit"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default WalletPayoutModal;
